export const LANDING = '/';
export const CREATE_USER = '/createuser';
export const ALL_USERS = '/allusers';
export const SIGN_IN = '/signin';
export const PASSWORD_FORGET = '/pw-forget';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const CREATE_COMPLAIN = '/createcomplain';
export const EDIT_USER = '/edituser';
export const EDIT_USER_PASSWORD = '/editcredentials'



// WEBPACK FOOTER //
// ./src/constants/routes.js